import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import {
    ScrollToTopOnMount,
} from 'wanderu-hocs';

import reducerMap from './ducks';

const UniversalHomePageContainer = withInterstitial(import('./pages/HomePage'), {
    onLoad(module, info, props, context) {
        context.store.inject({
            ...reducerMap,
        });
    },
});

const routes = [{
    path: '/',
    key: 'homepage',
    component: ScrollToTopOnMount(UniversalHomePageContainer),
    exact: true,
}];

export { routes };
export default {
    routes,
};
